// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.textLinked-module_textLinkedStyled__OXujC a:link,
.textLinked-module_textLinkedStyled__OXujC a:visited {
    text-decoration: none;
    color: var(--black);
}`, "",{"version":3,"sources":["webpack://./../../packages/consumer/src/widgets/Text/styles/textLinked.module.css"],"names":[],"mappings":"AAAA;;IAEI,qBAAqB;IACrB,mBAAmB;AACvB","sourcesContent":[".textLinkedStyled a:link,\n.textLinkedStyled a:visited {\n    text-decoration: none;\n    color: var(--black);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"textLinkedStyled": `textLinked-module_textLinkedStyled__OXujC`
};
export default ___CSS_LOADER_EXPORT___;
